import React, { FunctionComponent, ReactNode } from 'react';
import Box from '@amzn/awsui-components-react-v3/polaris/box';
import './common.css';

interface KeyValueProps {
	label: string;
	children?: ReactNode;
}

export const KeyValue: FunctionComponent<KeyValueProps> = ({
	label,
	children,
	...props
}) => {
	return (
		<div {...props} data-testid={`${label}-key-value`}>
			<Box variant="awsui-key-label">{label}</Box>
			<div id="review">{children}</div>
		</div>
	);
};
